import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { RxDragHandleDots2 } from "react-icons/rx";
import { MdSearch, MdAdd, MdSettings, MdMoreHoriz, MdOutlineAddTask, MdCopyAll } from 'react-icons/md';
import { TbEyeEdit } from "react-icons/tb";
import { CgLockUnlock, CgLock } from "react-icons/cg";
import Photosicon from '../../assets/photos_icon.png';
import { GoTasklist } from "react-icons/go";
import TaskEditws from './task-edit-ws';
export default function Sortabletask({ datarow, navigate }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: datarow.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  const [showedittask, setShowedittask] = useState(false);
  const [searchParams] = useSearchParams();
  const [puid, setpuid] = useState([]);
  const [taskuid, settaskuid] = useState([]);
  //activetask
  useEffect(() => {
    setpuid(searchParams.get('puid'));
    settaskuid(searchParams.get('taskuid'));

  }, [searchParams]);
  return (

    <div
      key={datarow.id}
      className='table-items' style={{ ...style, borderTop: 'solid 5px ' + datarow.color }}

      ref={setNodeRef}

      {...attributes}
    >
      {/* Entire card is clickable here */}
      <div

      >
        <table style={{ width: '100%' }}>
          <tbody>
            <tr>
              <td className='item-title'>
                <div style={{
                  width: '30px',
                  height: '25px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '0 0px',
                }}>
                  <RxDragHandleDots2 title='Drag Drop' className='move-img' {...listeners} />
                  {<div>{datarow.indexstage}</div>}
                </div>
              </td>
              {/* <td><input className='task-Checkbox' type='Checkbox' /></td> */}
              <td>

                <table width='100%'>
                  <tr>
                    <td><div onClick={() => {
                      navigate(`?puid=${datarow.puid}&taskuid=${datarow.taskuid}`);
                      // settaskselectdata(datarow.taskuid);
                    }}
                      style={{ cursor: 'pointer' }} className='task-name-text'>{datarow.taskname || ""}</div></td>
                    <td width='20px'>
                      <TbEyeEdit onClick={() => setShowedittask(true)} title='Edit Item' className='taskicon' />
                      {showedittask && (
                        <TaskEditws data={datarow} onClose={() => setShowedittask(false)} />
                      )}
                    </td>
                  </tr>
                </table>
              </td>

            </tr>

            <tr>
              <td className='item-title'>Status</td>

              <table ><tr>
                <td>
                  <div className="status-div"
                    onClick={() => {
                      navigate(`?puid=${datarow.puid}&taskuid=${datarow.taskuid}`);
                      // settaskselectdata(datarow.taskuid);
                    }}

                  >
                    {datarow.itemstatus === "Not accepted" ? (
                      <div className="done_yellow">Not accepted</div>
                    ) : (
                      <>
                        <div className="done_yellow">
                          Not Started
                        </div>
                        <div className="done_red">
                          Working
                        </div>
                        <div className="done_green">
                          Done
                        </div>
                      </>
                    )}
                  </div>
                </td>
                <td width='22px'>
                  {datarow.locked === false ? (
                    <CgLockUnlock title='Update item' style={{ color: '#f31d1d' }} className='taskicon' />
                  ) : (
                    <CgLock title='Item Locked' style={{ color: '#4caf50' }} className='taskicon' />
                  )}
                </td>
              </tr>
              </table>
            </tr>
            <tr>
              <td className='item-title'>Owner</td>
              <td>
                <table width='100%'><tr>
                  <td><img className='owner-img' src={Photosicon}></img></td>
                  <td> </td>
                  <td> </td>
                  <td width='20px'>
                    <MdAdd title='Add Owner' className='taskicon' />
                  </td>
                </tr></table>
              </td>
            </tr>
            <tr>
              <td className='item-title'>Update</td>
              <td>
                <table width='100%'><tr>
                  <td></td>
                  <td> {datarow?.update_date_time?.toDate?.()?.toLocaleString?.() || 'No subject'}</td>
                  <td width='20px'>
                    <MdCopyAll title='Task CopyAll' className='taskicon' />
                  </td>

                </tr>
                </table>
              </td>
            </tr>
            <tr >
              <td className='item-title'>Create</td>
              <td >
                <table width='100%'><tr>
                  <td title='Create Date'>

                    <span>{datarow?.date_time?.toDate?.()?.toISOString?.().split("T")[0]}</span>
                  </td>
                  <td><div>&nbsp;Due</div></td>
                  <td title='Due Date'>
                    <span>{datarow?.due_date_time?.toDate?.()?.toISOString?.().split("T")[0]}</span>
                  </td>
                </tr></table>
              </td>
            </tr>
            <tr>
              <td className='item-title'>Note</td>
              <td>
                <table width='100%'><tr>
                  <td>Add</td>
                  <td width='20px'>
                    <MdAdd title='Add Owner' className='taskicon' />
                  </td>
                </tr></table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  );
}
